import { RootScopeDeclare } from "src/app/core/rootscope-declare";
import { FacilityConsoleEquipmentsObject, FacilityObject } from "src/app/core/services/facility.model";

export class SelectionInfo {
  activityId: string;
  consoleType: string;
  facility: FacilityObject;
  rootScopeData: RootScopeDeclare;
  multiFacilities: string[];
  consoleObj: FacilityConsoleEquipmentsObject;
}